import { Shield, Eye, User } from 'lucide-react';

// ── Role styling ──────────────────────────────────────────────────────
export const ROLE_COLORS: Record<string, string> = {
  owner: 'bg-violet-500/10 text-violet-400 border-violet-500/30',
  admin: 'bg-blue-500/10 text-blue-400 border-blue-500/30',
  member: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30',
  user: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30',
  viewer: 'bg-gray-500/10 text-gray-400 border-gray-500/30',
};

export const ROLE_ICONS: Record<string, typeof Shield> = {
  owner: Shield,
  admin: Shield,
  member: User,
  viewer: Eye,
};

// ── Event styling ─────────────────────────────────────────────────────
export const EVENT_COLORS: Record<string, string> = {
  'record.created': 'bg-emerald-500',
  'record.updated': 'bg-blue-500',
  'record.deleted': 'bg-red-500',
  'rule.executed': 'bg-emerald-500',
  'rule_created': 'bg-emerald-500',
  'entity.created': 'bg-amber-500',
  'entity.updated': 'bg-amber-500',
  'site_deployed': 'bg-violet-500',
  'user.created': 'bg-gray-400',
  'login': 'bg-gray-400',
  'signup': 'bg-gray-400',
};

// ── Invitation status → badge variant ─────────────────────────────────
export const INVITATION_STATUS_MAP: Record<string, 'active' | 'inactive' | 'pending'> = {
  pending: 'pending',
  accepted: 'active',
  expired: 'inactive',
};

// ── Entity CRUD permission names ──────────────────────────────────────
export const ENTITY_PERMS = ['create', 'read', 'update', 'delete'] as const;

// ── Webhook event types ───────────────────────────────────────────────
export const WEBHOOK_EVENT_TYPES = ['record.created', 'record.updated', 'record.deleted'] as const;

// ── Public API key scopes ─────────────────────────────────────────────
export const VALID_SCOPES = [
  'records:read',
  'records:write',
  'channels:read',
  'channels:write',
  'entities:read',
  'entities:write',
  'knowledge:read',
] as const;

export const DEFAULT_TTL_DAYS = 365;
export const DEFAULT_RATE_PER_MIN = 60;
export const DEFAULT_RATE_PER_DAY = 1000;

// ── Fyso Teams app entitlement ────────────────────────────────────────
export const FYSO_TEAMS_SOURCE_ID = '65422493-73d8-4e74-a879-defa3a9771f1';

// ── Knowledge document styling ────────────────────────────────────────
export const KNOWLEDGE_STATUS_COLORS: Record<string, string> = {
  ready: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  processing: 'bg-orange-500/10 text-orange-400 border-orange-500/20',
  failed: 'bg-red-500/10 text-red-400 border-red-500/20',
};
